import { NumberSymbol } from '@angular/common';

export class MassPurchaseOrderModel {
    customerContact: string;
    priceId: number;
    productId: number;
    orderCount: number;
    discountCode: string;
}